import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { RESPONSE_API_URL } from "config";

// reports-b "Customise Layout" persistence (per-tenancy, inherited up the
// parent chain then tenancy 0). Backed by the reporting service's
// /dashboard/layout endpoints. Mirrors dashboard.service auth handling.
const baseQuery = fetchBaseQuery({
    baseUrl: RESPONSE_API_URL,
    prepareHeaders: (headers) => {
        const user = localStorage.getItem('user');
        if (user) {
            const token = JSON.parse(user).token;
            if (token) headers.set('authorization', `Bearer ${token}`);
        }
        return headers;
    },
    credentials: "omit"
});

export const reportLayoutApi = createApi({
    reducerPath: "reportLayoutApi",
    baseQuery,
    endpoints: (builder) => ({
        // Effective (inheritance-resolved) layout for every page of a tenancy:
        // { tenancyId, pages: { summary|sims|courses: { page, hidden[], templates[], source } } }
        getLayout: builder.query({
            query: (tenancyId) => ({ url: `dashboard/layout/${tenancyId}`, method: 'GET' }),
        }),
        // Save one page's layout for the tenancy. body: { page, hidden[], templates[] }
        saveLayout: builder.mutation({
            query: ({ tenancyId, page, hidden, templates }) => ({
                url: `dashboard/layout/${tenancyId}`,
                method: 'PUT',
                body: { page, hidden, templates },
            }),
        }),
        // Reset one page back to inherited (removes this tenancy's record).
        resetLayout: builder.mutation({
            query: ({ tenancyId, page }) => ({
                url: `dashboard/layout/${tenancyId}/${page}`,
                method: 'DELETE',
            }),
        }),
    }),
});

export const { useGetLayoutQuery, useSaveLayoutMutation, useResetLayoutMutation } = reportLayoutApi;
